import { buildFormData } from "./payload.helper";

const settingsHelper = {
  forSave: ({
    website_name,
    footer_about,
    header_logo,
    footer_logo,
    dark_header_logo,
    dark_footer_logo,
    favicon,
  }) =>
    buildFormData({
      website_name,
      footer_about,
      header_logo,
      footer_logo,
      dark_header_logo,
      dark_footer_logo,
      favicon,
    }),
};

export default settingsHelper;
